module.exports = __webpack_public_path__ + "img/team2.a573c65e.png";